module.exports = __webpack_public_path__ + "img/pse.42f2391e.svg";